import { useStaticQuery, graphql } from 'gatsby';

import { useLanguage } from './useLanguage';

export const useUseStaticQuery = () => {
  const { langKey } = useLanguage();
  const {
    sitePathsNodes,
    authorsPathsNodes,
    articlesPathsNodes,
    navbarContent,
    footerContent,
    commonContent
  } = useStaticQuery(
    graphql`
      query content {
        sitePathsNodes: allContentfulPage {
          nodes {
            ...PagePathFragment
          }
        }
        authorsPathsNodes: allContentfulAuthor {
          nodes {
            ...AuthorPathFragment
          }
        }
        articlesPathsNodes: allContentfulArticle {
          nodes {
            ...ArticlePathFragment
          }
        }
        navbarContent: allContentfulNavbar {
          nodes {
            ...NavbarFragment
          }
        }
        footerContent: allContentfulFooter {
          nodes {
            ...FooterFragment
          }
        }
        commonContent: allContentfulCommonContent {
          nodes {
            id
            node_locale
            translations {
              api
              blog
              terms
              company
              customs
              freight
              packing
              privacy
              delivery
              platform
              presskit
              services
              insurance
              artGallery
              collection
              marketplace
              auctionHouse
              antiqueDealer
              designGallery
              interiorDesigner
              specialProjects
              authorPageOtherAuthorsTitle
              authorPageOtherAuthorsArticleTitle
              buttonLabelSubscribe
              buttonLabelNew
              buttonLabelLogin
              buttonLabelNext
              buttonLabelSearch
              buttonLabelApply
              buttonLabelCancel
              buttonLabelSave
              buttonLabelQuote
              buttonLabelBackToTop
              buttonLabelCustomQuote
              buttonLabelInstantQuote
              buttonLabelBackToEmailPreferences
              formNewsletterTooltipDescription
              formNewsletterSuccessMessage
              placeholderReasonForUnsubscribeDetails
              placeholderEmail
              placeholderCityOrZipcodeDestination
              placeholderCityOrZipcodeCollection
              placeholderResultsEmpty
              placeholderResultsEmptyValue
              placeholderEmail
              geolocalisationAvailableShippingOptionsMessage
              geolocalisationCustomQuoteMessage
              geolocalisationModuleTitle
              geolocalisationModuleFrom
              geolocalisationModuleTo
              preferencesReasonForUnsubscribeOther
              preferencesReasonForUnsubscribeTooManyEmails
              preferencesReasonForUnsubscribeNotInterested
              preferencesUnsubscribeTitle
              preferencesUnsubscribeDescription
              preferencesWelcomePageTitle
              preferencesFeedbackTitle
              preferencesThankYouTitle
              preferencesChangesSavedTitle
              preferencesErrorMessageTitle
              preferencesDirectContactWithConvelioTeamTitle
              preferencesThankYouDescription
              preferencesChangesSavedDescription
              preferencesErrorMessageDescription
              preferencesSwitchAllTitle
              preferencesSwitchAllDescription
              preferencesConvelioInsiderTitle
              preferencesConvelioInsiderDescription
              preferencesConvelioInsiderExamples
              preferencesProductReleasesTitle
              preferencesProductReleasesDescription
              preferencesProductReleasesExamples
              preferencesSmarterShippingTitle
              preferencesSmarterShippingDescription
              preferencesSmarterShippingExamples
              preferencesMarketInsightsTitle
              preferencesMarketInsightsDescription
              preferencesMarketInsightsExamples
              preferencesUnsubscribeReasonTitle
              preferencesFeedbackDescription
            }
            externalLinks {
              quoting
              login
              signup
              apiDocumentation
              careers
              helpCenter
              data
              apiQuiz
              apiSendDemo
              widgetDocumentation
              apiFaqPdf
              contactUsApiPage
              contactUs
              presskit
              logos
              parisOffice
              londonOffice
              newYorkOffice
              frNumber
              itNumber
              ukNumber
              usaNumber
              convelioGeneralEmail
              climateCarePdf
            }
          }
        }
      }
    `
  );

  // Get content  for current lang
  const getTranslatedContent = (content) => {
    return content?.nodes?.find((node) => node.node_locale === langKey);
  };

  const { translations, externalLinks } = getTranslatedContent(commonContent);
  const navbar = getTranslatedContent(navbarContent);
  const footer = getTranslatedContent(footerContent);
  const { nodes: sitePaths } = sitePathsNodes;
  const { nodes: authorsPaths } = authorsPathsNodes;
  const { nodes: articlesPaths } = articlesPathsNodes;

  return {
    sitePaths,
    authorsPaths,
    articlesPaths,
    navbar,
    footer,
    translations,
    externalLinks
  };
};
